var Kowloon = "Kowloon";
var HKStates = {
	"Hong Kong Island": "Hong Kong Island",
	Kowloon: Kowloon,
	"Lantau Island": "Lantao Island",
	"New Territories": "Neue Territorien"
};

export { Kowloon, HKStates as default };
